enum CumulAccess {
  // in descending order from the most to least rights
  CAN_OWN = "canOwn",
  CAN_EDIT = "canEdit",
  CAN_USE = "canUse", // same as canView, but can also clone and then edit
  CAN_VIEW = "canView",
}

export default CumulAccess;
